<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-md-offset-1">
        <div class="card card-wizard" id="wizardCard">
          <form-wizard error-color="#EB5E28" color="#1e94fd" title="Movimientos del padrón" subtitle="">
            <div>
              <b-tabs content-class="mt-3">
                <b-tab title="Consulta general" active lazy>
                  <consulta ref="Consulta"></consulta>
                </b-tab>
                <b-tab title="Movimientos" lazy>
                  <lista ref="Lista"></lista>
                </b-tab>
                <b-tab title="Licencias" lazy>
                  <licencias ref="Licencias"></licencias>
                </b-tab>
                <b-tab title="VoBo. Correcciones" lazy>
                  <correcciones ref="Correcciones"></correcciones>
                </b-tab>
                <!-- v-if="getKey('permisos').includes(20)  -->
                <b-tab title="Declaraciones" lazy v-if="(rol == 1)">
                  <lista-correcciones ref="Declaraciones"></lista-correcciones>
                </b-tab>
                <b-tab title="Transferencias" lazy v-if="(rol == 1)">
                  <transferencias ref="Transferencias"></transferencias>
                </b-tab>
                <b-tab title="Servidores inactivos" lazy>
                  <inactivos ref="Inactivos"></inactivos>
                </b-tab>
              </b-tabs>
            </div>
            <button slot="next" class="d-none">Siguiente</button>
            <button slot="finish" class="d-none">Siguientes</button>
          </form-wizard>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    FormWizard,
    TabContent
  } from "vue-form-wizard";
  import "vue-form-wizard/dist/vue-form-wizard.min.css";
  import Consulta from "./Formularios/Movimientos/Movimientos.vue";
  import Licencias from "./Formularios/Movimientos/Licencias.vue";
  import Lista from "./Formularios/Movimientos/ListaMovimientos.vue";
  import ListaCorrecciones from "./Formularios/Movimientos/ListaCorrecciones.vue";
  import Correcciones from "./Formularios/Movimientos/Correcciones.vue";
  import HCorrecciones from "./Formularios/Movimientos/HCorrecciones.vue";
  import Transferencias from "./Formularios/Movimientos/Transferencias.vue";
  import Inactivos from "./Formularios/Movimientos/Inactivos.vue";
  /*  import Membresias from "./Formularios/Intereses/Membresias.vue";
import Apoyos from "./Formularios/Intereses/Apoyos.vue";
  import Representacion from "./Formularios/Intereses/Representacion.vue";
  import RepresentacionPasiva from "./Formularios/Intereses/RepresentacionPasiva.vue";
  import SociosComerciales from "./Formularios/Intereses/SociosComerciales.vue";
  import ClientesPrincipales from "./Formularios/Intereses/ClientesPrincipales.vue";
  import OtrasPartes from "./Formularios/Intereses/OtrasPartes.vue";
  import BeneficiosPrivados from "./Formularios/Intereses/BeneficiosPrivados.vue"; */
  import swal from "sweetalert2";
  export default {
    data() {
      return {
        wizardModel: {},
        rol: null,
      };
    },
    components: {
      FormWizard,
      TabContent,
      Consulta,
      Licencias,
      Lista,
      ListaCorrecciones,
      Correcciones,
      HCorrecciones,
      Transferencias,
      Inactivos
      /*  Membresias,
       Apoyos,
       Representacion,
       RepresentacionPasiva,
       SociosComerciales,
       ClientesPrincipales,
       OtrasPartes,
       BeneficiosPrivados, */

    },
    watch: {
      '$route': 'checkPermissions'
    },
    methods: {
      checkPermissions() {
        let permiso = [4];
        if (!this.getKey('permisos').some(r => permiso.includes(r))) {
          localStorage.clear();
          this.$router.push('/login');
          this.$router.go();
        }
      },
      validateFirstStep() {
        return this.$refs.firstStep.validate();
      },
      validateSecondStep() {
        return this.$refs.secondStep.validate();
      },
      wizardComplete() {
        // we gather models from all steps into one model
        this.wizardModel = {
          ...this.$refs.datosPersonales.model,
          ...this.$refs.firstStep.model,
          ...this.$refs.DatosCurriculares.model,
          ...this.$refs.DatosConyuge.model,
          ...this.$refs.secondStep.model
        };
        swal("Good job!", "You clicked the finish button!", "success");
      },
      siguente() {
        this.$router.push("ingresos");
      }
    },
    created() {
      this.rol = this.getKey('role');
      this.checkPermissions()
    }
  };

</script>
<style>
  .vue-form-wizard .wizard-icon-circle.tab_shape {
    background-color: #9a9a9a !important;
    color: white;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Movimientos.vue